<template>
  <el-aside width="200px"
            class="layout-sider-nav">
    <div class="sider-title">{{userInfo.userType | loginType()}}</div>
    <el-menu :default-active="defaultActive"
             :unique-opened="true"
             background-color="#001529"
             text-color="#BFCBD9"
             active-text-color="#fff">
      <template v-for="menu in menuData">
        <!-- <el-submenu :key="menu.funcAddress"
                    :index="menu.funcAddress"
                    v-if="menu.children">
          <span slot="title">{{ menu.menuName }}</span>
          <el-menu-item-group>
            <el-menu-item :key="subIndex"
                          :index="children.funcAddress"
                          v-for="(children, subIndex) in menu.children"
                          @click="openUrl(children.funcAddress)">{{ children.menuName }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item :key="menu.funcAddress"
                      :index="menu.funcAddress"
                      @click="openUrl(menu.funcAddress)"
                      v-else>
          <span slot="title">{{ menu.menuName }}</span>
        </el-menu-item> -->
        <template v-if="menu.children && menu.children.length > 0">
          <draggable-sub-menu-new :funcAddress="menu.funcAddress"
                                  :key="menu.funcAddress"
                                  :menuName="menu.menuName"
                                  :children="menu.children" />
        </template>
        <template v-else>
          <el-menu-item :key="menu.funcAddress"
                        :index="menu.funcAddress"
                        @click="openUrl(menu.funcAddress)">
            <span slot="title">{{ menu.menuName }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
    <!-- <open-wxapp-page v-if="showWxapp" /> -->
  </el-aside>
</template>
<script>
import { mapState } from 'vuex'
import DraggableSubMenuNew from '../nav-menu/draggable-sub-menu-new.vue'
// import OpenWxappPage from './open-wxapp-page.vue'
export default {
  name: 'layout-sider',
  components: { DraggableSubMenuNew },
  data () {
    return {
      // showWxapp: window.location.host.includes(process.env.VUE_APP_SHOW_WXAPP_ORIGIN)
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      menu: state => state.account.menu,
      menuLayout: state => state.account.menuLayout
    }),
    defaultActive () {
      return this.$route.meta.activePath
    },
    menuData ({ menu, menuLayout, $route }) {
      if (menuLayout === 1) {
        return menu
      } else {
        const topActivePath = $route.meta.topActivePath
        const menuList = menu.find(i => i.funcAddress === topActivePath) || {}
        return menuList.children || []
      }
    }
  },
  methods: {
    openUrl (url) {
      this.$store.commit('common/resetQuery', {})
      this.$router.push(url)
    }
  }
}
</script>
<style lang="stylus">
.layout-sider-nav {
  // width: 200px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #002140;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.5);
  z-index: 10;

  .el-menu {
    border-right: none;

    .el-menu-item.is-active {
      background-color: #1890ff !important;
    }

    .el-menu-item-group__title {
      display: none;
    }

    .el-menu-item-group .el-menu-item:not(.is-active) {
      background-color: #000c17 !important;
    }
  }

  .el-menu-item, .el-submenu__title {
    height: 48px !important;
    line-height: 48px !important;
  }

  .el-submenu .el-menu-item {
    height: 44px !important;
    line-height: 44px !important;
  }

  .sider-title {
    height: 52px;
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
  }
}
</style>
